// Initial products to show before AI recommendations
export const initialProducts = [
  {
    id: 1,
    displayName: "Aventho 100",
    image: "/Assets/Products/aventho-100-creme-on-ear-kopfhoerer-anc-beyerdynamic-side.webp",
    variantImage: "/Assets/VariantImages/aventho100.webp",
    // price: "199,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Kompakter On-Ear Wireless Kopfhörer mit ANC für unterwegs mit bis zu 40 Stunden Akkulaufzeit.",
      en: "Compact On-Ear wireless headphones with ANC for on the go, with up to 40 hours of battery life.",
      pl: "Kompaktowe bezprzewodowe słuchawki nauszne z ANC w podróży, z baterią o czasie pracy do 40 godzin."
    },
    link: "https://www.beyerdynamic.de/aventho-100",
    category: "ON-EAR"
  },
  {
    id: 2,
    displayName: "Aventho 200",
    image: "/Assets/Products/aventho-200-over-ear-kopfhoerer-mit-anc-nordic-grey-beyerdynamic-3.webp",
    variantImage: "/Assets/VariantImages/aventho200.webp",
    // price: "249,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Over-Ear mit über 60 Stunden Akku, ANC und Transparenzmodus für Reisen und Büro.",
      en: "Over-Ear with over 60 hours of battery, ANC and transparency mode for travel and the office.",
      pl: "Słuchawki wokółuszne z baterią o czasie pracy ponad 60 godzin, ANC i trybem transparentności – do podróży i biura."
    },
    link: "https://www.beyerdynamic.de/aventho-200",
    category: "OVER-EAR"
  },
  {
    id: 3,
    displayName: "Aventho 300",
    image: "/Assets/Products/aventho-300-over-ear-kopfhoerer-black-produkt3.webp",
    variantImage: "/Assets/VariantImages/aventho300.webp",
    // price: "299,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Premium-Allrounder mit STELLAR.45-Treibern, Dolby Atmos und 50h Akku mit ANC.",
      en: "Premium all-rounder with STELLAR.45 drivers, Dolby Atmos and 50h battery with ANC.",
      pl: "Wszechstronny model premium z przetwornikami STELLAR.45, Dolby Atmos i baterią 50h z ANC."
    },
    link: "https://www.beyerdynamic.de/aventho-300",
    category: "OVER-EAR"
  },
  {
    id: 4,
    displayName: "Amiron 100",
    image: "/Assets/Products/amiron-100-true-wireless-earphones-creme-case-open-beyerdynamic-4.webp",
    variantImage: "/Assets/VariantImages/amiron100.webp",
    // price: "99,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "True Wireless In-Ears mit ANC, 35h Gesamtlaufzeit und 6 Mikrofonen.",
      en: "True Wireless in-ears with ANC, 35h total playback time and 6 microphones.",
      pl: "Słuchawki dokanałowe True Wireless z ANC, łącznym czasem pracy 35h i 6 mikrofonami."
    },
    link: "https://www.beyerdynamic.de/amiron-100",
    category: "IN-EAR"
  },
  {
    id: 5,
    displayName: "Amiron 300",
    image: "/Assets/Products/amiron-300-true-wireless-earphones-anc-black-case-beyerdynamic.webp",
    variantImage: "/Assets/VariantImages/amiron300.webp",
    // price: "149,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Premium In-Ears mit 10mm Treibern, anpassbarer ANC und LDAC Hi-Res Audio.",
      en: "Premium in-ears with 10mm drivers, adjustable ANC and LDAC Hi-Res Audio.",
      pl: "Słuchawki dokanałowe premium z przetwornikami 10mm, regulowanym ANC i LDAC Hi-Res Audio."
    },
    link: "https://www.beyerdynamic.de/amiron-300",
    category: "IN-EAR"
  },
  {
    id: 6,
    displayName: "Amiron 200",
    image: "/Assets/Products/amiron-200-sport-open-ear-ohrhoerer-beyerdynamic-open-case-3.webp",
    variantImage: "/Assets/VariantImages/amiron200.webp",
    // price: "179,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Open-Ear Sport Ohrhörer mit IP54, 36h Akku und voller Umgebungswahrnehmung.",
      en: "Open-Ear sport earphones with IP54, 36h battery and full ambient awareness.",
      pl: "Sportowe słuchawki Open-Ear z IP54, baterią 36h i pełną świadomością otoczenia."
    },
    link: "https://www.beyerdynamic.de/amiron-200",
    category: "OPEN-EAR"
  },
  {
    id: 7,
    displayName: "Amiron Zero",
    image: "/Assets/Products/amiron-zero-open-ear-clip-earbud-beyerdynamic-3.webp",
    variantImage: "/Assets/VariantImages/amironzero.webp",
    // price: "149,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Innovativer Clip-Formfaktor, ultraleicht (6g) mit IP54 und 20h Spielzeit.",
      en: "Innovative clip form factor, ultra-light (6g) with IP54 and 20h playback time.",
      pl: "Innowacyjna forma klipsa, ultralekka (6g), z IP54 i czasem pracy 20h."
    },
    link: "https://www.beyerdynamic.de/amiron-zero",
    category: "OPEN-EAR"
  },
  // {
  //   id: 8,
  //   displayName: "MMX 150 Wireless",
  //   image: "/Assets/Products/mmx-150-wireless_arcticwhite_beyerdynamic_side.webp",
  //   variantImage: "/Assets/VariantImages/mmx150.webp",
  //   price: "179,00 €",
  //   originalPrice: null,
  //   shortDescription: "Gaming-Einstieg mit META VOICE Mikrofon, 50h Akku und Klangpersonalisierung.",
  //   link: "https://www.beyerdynamic.de/mmx-150-wireless",
  //   category: "OVER-EAR"
  // },
  // {
  //   id: 9,
  //   displayName: "MMX 230 Wireless",
  //   image: "/Assets/Products/PIC_MMX230-wireless-25-08-White_v1.png",
  //   variantImage: "/Assets/VariantImages/MMX230.webp",
  //   price: "249,00 €",
  //   originalPrice: null,
  //   shortDescription: "Kompetitives Gaming mit ANC, 60h Akku und Bluetooth 6.0.",
  //   link: "https://www.beyerdynamic.de/mmx-230-wireless",
  //   category: "OVER-EAR"
  // },
  // {
  //   id: 10,
  //   displayName: "MMX 300 PRO",
  //   image: "/Assets/Products/mmx-300-pro-gaming-headset-beyerdynamic-front.webp",
  //   variantImage: "/Assets/VariantImages/mmx300pro.webp",
  //   price: "249,00 €",
  //   originalPrice: null,
  //   shortDescription: "Professionelles Gaming mit STELLAR.45-Treiber, Kondensatormikrofon, Made in Germany.",
  //   link: "https://www.beyerdynamic.de/mmx-300-pro",
  //   category: "OVER-EAR"
  // },
  // {
  //   id: 11,
  //   displayName: "MMX 330 PRO",
  //   image: "/Assets/Products/mmx-330-pro-beyerdynamic-side.webp",
  //   variantImage: "/Assets/VariantImages/mmx330pro.webp",
  //   price: "249,00 €",
  //   originalPrice: null,
  //   shortDescription: "Taktisches Gaming mit offener Bauweise für räumliche Ortung, Made in Germany.",
  //   link: "https://www.beyerdynamic.de/mmx-330-pro",
  //   category: "OVER-EAR"
  // },
  {
    id: 12,
    displayName: "DJ 300 PRO X Club",
    image: "/Assets/Products/dj-300-pro-x-club-beyerdynamic-front.webp",
    variantImage: "/Assets/VariantImages/dj300proxclub.webp",
    // price: "199,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Lifestyle DJ-Kopfhörer mit auffälligem Design und personalisierbaren Ear-Cups.",
      en: "Lifestyle DJ headphones with eye-catching design and customizable ear-cups.",
      pl: "Słuchawki DJ-skie w stylu lifestyle z efektownym designem i personalizowanymi nausznikami."
    },
    link: "https://www.beyerdynamic.de/dj-300-pro-x-club",
    category: "OVER-EAR"
  },
  {
    id: 13,
    displayName: "Aventho Y",
    image: "/Assets/Products/PIC_AVENTHO-Y_26-06_Liquid-Black-Front-WHITE_v1.png",
    variantImage: "/Assets/VariantImages/aventho_y.png",
    // price: "199,00 €",
    // originalPrice: null,
    shortDescription: {
      de: "Wireless Over-Ear Kopfhörer mit ANC. Mehr als 90 Stunden Akkulaufzeit mit Fast Charging – für den täglichen Einsatz.",

    },
    link: "https://www.beyerdynamic.de/p/aventho-y",
    category: "OVER-EAR"
  }
];

